<nz-space nzDirection="vertical" style="width: 100%">
  <nz-space-item *ngIf="toBinActivated">
    <nz-select style="width: 100%" [(ngModel)]="toBinLocationValue" [nzSize]="'large'"
      [nzPlaceHolder]="'Receiving Bin:' | locale" #binLocation>
      <nz-option *ngFor="let binLocation of toBinLocations" [nzValue]="binLocation.AbsEntry"
        [nzLabel]="binLocation.BinCode">
      </nz-option>
    </nz-select>
  </nz-space-item>
  <nz-space-item>
    <nz-input-group [nzPrefix]="scanIcon" nzSize="large">
      <input nz-input nzSize="large" [(ngModel)]="batchSearchValue" [placeholder]="'Search for batch no.' | locale"
        [nzAutocomplete]="batchNumbersAuto" (blur)="searchForBatch(quantity)"
        (keydown)="searchForBatch(quantity, $event)" #batchSearch />
    </nz-input-group>
    <nz-autocomplete #batchNumbersAuto [nzDefaultActiveFirstOption]="false">
      <ng-container *ngFor="let batchNumber of batchNumbers">
        <nz-auto-option [nzValue]="batchNumber.DistNumber">
          {{ ((batchNumber.MnfSerial == null || batchNumber.MnfSerial === undefined || batchNumber.MnfSerial === '') ?
          batchNumber.DistNumber : batchNumber.MnfSerial )}} - {{'Qty: ' | locale}} {{batchNumber.Quantity / numPerSale
          | number}}
        </nz-auto-option>
      </ng-container>
    </nz-autocomplete>
    <ng-template #scanIcon>
      <i nz-icon nzType="barcode" nzTheme="outline"></i>
    </ng-template>
  </nz-space-item>
  <nz-space-item *ngIf="selectedBatch !== undefined">
    <nz-input-group [nzPrefix]="'Available Qty: ' | locale" nzSize="large">
      <input nz-input [ngModel]="(selectedBatch.Quantity / numPerSale) - selectedBatch.SelectedQty" readonly>
    </nz-input-group>
  </nz-space-item>
  <nz-space-item [hidden]="selectedBatch === undefined">
    <nz-input-number #quantity [nzParser]="numberParser"   [nzFormatter]="formatter"  nzSize="large" [(ngModel)]="currentQuantity" (change)="quantityInserted(batchSearch)"
      (keydown)="quantityInserted(batchSearch, $event)" [nzMin]="0" [nzPlaceHolder]="'Selected Qty' | locale">
    </nz-input-number>
  </nz-space-item>
  <nz-space-item>
    <nz-table #table [nzData]="this.batchNumbers">
      <thead>
        <tr>
          <th>
            {{'Batch details' | locale}}
          </th>
          <th>
            {{'Selected Qty' | locale}}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let batch of table.data">
          <td>
            {{((batch.MnfSerial == null || batch.MnfSerial === undefined || batch.MnfSerial === '') ?
            batch.DistNumber : batch.MnfSerial ) }}
            <span *ngIf="batch.ExpDateStr !== '' && batch.ExpDateStr !== undefined && batch.ExpDateStr !== null"> - {{'Exp. Date'
              |
              locale}} <b>{{batch.ExpDateStr | date}}</b></span>
            <span *ngIf="(batch.ExpDateStr === '' || batch.ExpDateStr === undefined || batch.ExpDateStr == null) && batch.ExpDate !== '' && batch.ExpDate !== undefined && batch.ExpDate !== null"> - {{'Exp. Date'
              |
              locale}} <b>{{batch.ExpDate | date}}</b></span>
            <br />
            {{'Available Qty' | locale}} <b>{{batch.Quantity / numPerSale | number}}</b>
          </td>
          <td>
            <nz-input-group nzSearch="true" [nzAddOnAfter]="toBinActivated ? toBinButton : undefined">
              <nz-input-number [nzParser]="numberParser"   [nzFormatter]="formatter"  [(ngModel)]="batch.SelectedQty" [ngModelOptions]="{ updateOn: 'blur'}"
                (ngModelChange)="selectedQtyChanged(batch);" style="width: 100%;"></nz-input-number>
            </nz-input-group>
            <ng-template #toBinButton>
              <button nz-button nzType="primary" nzSearch
                (click)="currentBatch = batch; batch.QtyDetailsDialog = true;">
                <i nz-icon nzType="unordered-list" nzTheme="outline"></i>
              </button>
            </ng-template>
          </td>
        </tr>
      </tbody>
    </nz-table>
  </nz-space-item>
</nz-space>
<nz-drawer [nzVisible]="currentBatch.QtyDetailsDialog" (nzOnClose)="currentBatch.QtyDetailsDialog = false;"
  [nzTitle]="'Receiver Bin Location Details' | locale" nzWrapClassName="drawer-size-3x" [nzFooter]="drawerFooter">
  <nz-descriptions [nzBordered]="true" [nzColumn]="{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 1 }">
    <nz-descriptions-item [nzTitle]="'Batch Number' | locale">
      {{currentBatch.DistNumber}}
    </nz-descriptions-item>
    <nz-descriptions-item [nzTitle]="'Required Qty' | locale">
      {{currentBatch.SelectedQty}}
    </nz-descriptions-item>
  </nz-descriptions>
  <br />
  <nz-table *ngIf="currentBatch.QtyDetailsDialog" #binQtyDetailsDialogTable [nzData]="toBinLocations">
    <thead>
      <tr>
        <th>
          {{'Bin Location' | locale}}
        </th>
        <th>
          {{'Quantity' | locale}}
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let toBin of binQtyDetailsDialogTable.data">
        <td>{{toBin.BinCode}}</td>
        <td>
          <nz-input-number [(ngModel)]="currentBatch['To-' + toBin.AbsEntry]">
          </nz-input-number>
        </td>
      </tr>
    </tbody>
  </nz-table>
</nz-drawer>
<ng-template #drawerFooter>
  <button nz-button nzType="primary" (click)="currentBatch.QtyDetailsDialog = false;">{{'Ok' | locale }}</button>
</ng-template>
